import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiDroplet, FiTool, FiPaintBucket, FiLayers, FiGrid } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiDroplet,
      title: 'Bathroom Remodeling',
      description: 'Complete bathroom renovations from modern updates to luxury spa-like retreats.',
      features: ['Custom tile work', 'Plumbing updates', 'Modern fixtures', 'Accessibility features'],
      image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: FiTool,
      title: 'Kitchen Remodeling',
      description: 'Transform your kitchen into the heart of your home with custom designs.',
      features: ['Custom cabinets', 'Countertop installation', 'Modern appliances', 'Island design'],
      image: 'https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: FiHome,
      title: 'Whole Home Renovation',
      description: 'Complete home transformations with attention to every detail.',
      features: ['Structural changes', 'Room additions', 'Open floor plans', 'Energy efficiency'],
      image: 'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: FiPaintBucket,
      title: 'Interior Design',
      description: 'Professional interior design services to complement your renovation.',
      features: ['Color consultation', 'Material selection', 'Space planning', 'Finishing touches'],
      image: 'https://images.unsplash.com/photo-1600585152220-90363fe7e115?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: FiLayers,
      title: 'Flooring Installation',
      description: 'High-quality flooring installation for any room in your home.',
      features: ['Hardwood floors', 'Tile installation', 'Laminate options', 'Carpet installation'],
      image: 'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: FiGrid,
      title: 'Custom Carpentry',
      description: 'Skilled craftsmanship for custom built-ins and woodwork.',
      features: ['Built-in shelving', 'Custom cabinets', 'Trim work', 'Furniture pieces'],
      image: 'https://images.unsplash.com/photo-1588854337115-1c67d9247e4d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From concept to completion, we provide comprehensive remodeling services to transform your vision into reality.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors">
                <SafeIcon icon={service.icon} className="w-8 h-8 text-blue-600 group-hover:text-white transition-colors" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-gray-700">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;